import React, { useState } from "react";
//Dropdown menu component
import { NavDropdown } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const DropdownMenu = (props) => {
  const [show, setShow] = useState(false);

  const showDropdown = () => {
    setShow(true);
  };
  const hideDropdown = () => {
    setShow(false);
  };

  const propClass = props.className;

  return (
    <NavDropdown
      title={
        props.mainLink ? (
          <NavLink to={props.mainLink}>
            {props.title} {props.icon}
          </NavLink>
        ) : (
          <span>
            {props.title} {props.icon}
          </span>
        )
      }
      className={propClass}
      show={show}
      onMouseEnter={showDropdown}
      onMouseLeave={hideDropdown}
    >
      {props.links.map((item) => {
        return (
          <NavDropdown.Item as={NavLink} to={item["link"]}>
            {item["name"]}
          </NavDropdown.Item>
        );
      })}
    </NavDropdown>
  );
};

export default DropdownMenu;
